var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailComment = function SvgReportDetailComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.37 2H3.63A2.63 2.63 0 0 0 1 4.63v5.968a2.63 2.63 0 0 0 2.63 2.63h2.257q.053 0 .09.038l1.247 1.292c.422.435 1.116.45 1.556.032l1.395-1.328a.13.13 0 0 1 .082-.035h2.11A2.63 2.63 0 0 0 15 10.598V4.63A2.63 2.63 0 0 0 12.37 2m1.65 8.598c0 .911-.738 1.65-1.65 1.65h-2.109c-.284 0-.556.109-.762.304l-1.395 1.33a.126.126 0 0 1-.176 0l-1.247-1.3a1.11 1.11 0 0 0-.794-.337H3.629a1.65 1.65 0 0 1-1.65-1.647V4.63c.001-.91.74-1.649 1.65-1.65h8.742c.91.001 1.649.74 1.65 1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.053 5.596H4.98a.49.49 0 1 0 0 .98h6.073a.49.49 0 1 0 0-.98M8.902 8.788H4.98a.49.49 0 0 0 0 .98h3.918a.49.49 0 0 0 0-.98z"
  }))));
};
export default SvgReportDetailComment;